import { render, staticRenderFns } from "./monograph.vue?vue&type=template&id=0e2c427c&scoped=true"
import script from "./monograph.vue?vue&type=script&lang=js"
export * from "./monograph.vue?vue&type=script&lang=js"
import style0 from "./monograph.vue?vue&type=style&index=0&id=0e2c427c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2c427c",
  null
  
)

export default component.exports